:host{display:block}.layer{pointer-events:none}.layer.active-layer{pointer-events:visiblePainted}
/*# sourceMappingURL=layers.component.css.map */
